const fields = [
  { label: "Tag", name: "tag", type: "text" },
  { label: "Business Context", name: "businessContext", EditorText: true },
  { label: "Value Delivered", name: "valueDelivered", EditorText: true },
];

export default fields;
